export default __webpack_public_path__ + "0f31ad56837c49ac9c0cfbdd3b91db94.svg";